import React from 'react';
import { CTAButton } from './CTAButton';
export function HeroSection() {
  return <section className="relative pt-6 pb-2 px-4 overflow-hidden" data-id="element-78">
      {/* Blurred Background Image */}
      <div className="absolute inset-0 z-0" data-id="element-79">
        <img src="https://cdn.magicpatterns.com/uploads/x8AMYd4jZEPUhc4jKZ1W2q/Firefly_Gemini_Flash_Haceme_una_tarotista_dando_una_carta_natal_que_la_foto_se_vea_sumamente_profesional_m_10276.png" alt="" className="w-full h-full object-cover" style={{
        filter: 'blur(12px)',
        transform: 'scale(1.05)'
      }} data-id="element-80" />
        {/* Dark overlay for text readability */}
        <div className="absolute inset-0 bg-[#1a1040]/75" data-id="element-81" />
        {/* Bottom gradient fade into page */}
        <div className="absolute inset-0 bg-gradient-to-b from-transparent via-transparent to-[#1a1040]" data-id="element-82" />
      </div>

      <div className="relative z-10 max-w-5xl mx-auto text-center" data-id="element-83">
        {/* Main Heading */}
        <h1 className="text-3xl md:text-4xl lg:text-5xl font-black text-white mb-4 leading-tight mystic-glow drop-shadow-lg" data-id="element-84">
          Dejá de perder horas preparando{' '}
          <span className="text-gold-gradient" data-id="element-85">informes desde cero</span>
        </h1>

        {/* Product Image - Clickable */}
        <a href="#comprar" className="block cursor-pointer transition-transform hover:scale-105 duration-300" data-id="element-86">
          <img src="https://cdn.magicpatterns.com/uploads/egSk7yA3Ya5VsD7DeFvht1/Mockup_principal.png" alt="Sistema Pro Cartas Natales - Informes profesionales para astrólogas" className="max-w-[70%] md:max-w-[60%] mx-auto drop-shadow-2xl" data-id="element-87" />
        </a>

        {/* Subheading - Below mockup */}
        <p className="text-lg md:text-xl text-white mt-6 mb-8 max-w-2xl mx-auto leading-relaxed drop-shadow-md" data-id="element-88">
          Sistema completo de informes astrológicos profesionales listos para
          entregar. Todo tu flujo de trabajo anual resuelto en un clic.
        </p>

        {/* CTA Button */}
        <div data-id="element-89">
          <CTAButton href="#comprar" size="large" data-id="element-90">
            ¡QUIERO EL SISTEMA AHORA!
          </CTAButton>
        </div>
      </div>
    </section>;
}